// 鼓音檔配置
export const DRUM_SAMPLES = {
  kick: [
    { id: 'kick-808', name: '808 Kick', file: '/samples/kick-808.wav' },
    { id: 'kick-acoustic01', name: 'Acoustic Kick 1', file: '/samples/kick-acoustic01.wav' },
    { id: 'kick-acoustic02', name: 'Acoustic Kick 2', file: '/samples/kick-acoustic02.wav' },
    { id: 'kick-big', name: 'Big Kick', file: '/samples/kick-big.wav' },
    { id: 'kick-classic', name: 'Classic Kick', file: '/samples/kick-classic.wav' },
    { id: 'kick-cultivator', name: 'Cultivator Kick', file: '/samples/kick-cultivator.wav' },
    { id: 'kick-deep', name: 'Deep Kick', file: '/samples/kick-deep.wav' },
    { id: 'kick-dry', name: 'Dry Kick', file: '/samples/kick-dry.wav' },
    { id: 'kick-electro01', name: 'Electro Kick 1', file: '/samples/kick-electro01.wav' },
    { id: 'kick-electro02', name: 'Electro Kick 2', file: '/samples/kick-electro02.wav' },
    { id: 'kick-floppy', name: 'Floppy Kick', file: '/samples/kick-floppy.wav' },
    { id: 'kick-gritty', name: 'Gritty Kick', file: '/samples/kick-gritty.wav' },
    { id: 'kick-heavy', name: 'Heavy Kick', file: '/samples/kick-heavy.wav' },
    { id: 'kick-newwave', name: 'New Wave Kick', file: '/samples/kick-newwave.wav' },
    { id: 'kick-oldschool', name: 'Old School Kick', file: '/samples/kick-oldschool.wav' },
    { id: 'kick-plain', name: 'Plain Kick', file: '/samples/kick-plain.wav' },
    { id: 'kick-slapback', name: 'Slapback Kick', file: '/samples/kick-slapback.wav' },
    { id: 'kick-softy', name: 'Soft Kick', file: '/samples/kick-softy.wav' },
    { id: 'kick-stomp', name: 'Stomp Kick', file: '/samples/kick-stomp.wav' },
    { id: 'kick-tape', name: 'Tape Kick', file: '/samples/kick-tape.wav' },
    { id: 'kick-thump', name: 'Thump Kick', file: '/samples/kick-thump.wav' },
    { id: 'kick-tight', name: 'Tight Kick', file: '/samples/kick-tight.wav' },
    { id: 'kick-tron', name: 'Tron Kick', file: '/samples/kick-tron.wav' },
    { id: 'kick-vinyl01', name: 'Vinyl Kick 1', file: '/samples/kick-vinyl01.wav' },
    { id: 'kick-vinyl02', name: 'Vinyl Kick 2', file: '/samples/kick-vinyl02.wav' },
    { id: 'kick-zapper', name: 'Zapper Kick', file: '/samples/kick-zapper.wav' },
  ],
  snare: [
    { id: 'snare-808', name: '808 Snare', file: '/samples/snare-808.wav' },
    { id: 'snare-acoustic01', name: 'Acoustic Snare 1', file: '/samples/snare-acoustic01.wav' },
    { id: 'snare-acoustic02', name: 'Acoustic Snare 2', file: '/samples/snare-acoustic02.wav' },
    { id: 'snare-analog', name: 'Analog Snare', file: '/samples/snare-analog.wav' },
    { id: 'snare-big', name: 'Big Snare', file: '/samples/snare-big.wav' },
    { id: 'snare-block', name: 'Block Snare', file: '/samples/snare-block.wav' },
    { id: 'snare-brute', name: 'Brute Snare', file: '/samples/snare-brute.wav' },
    { id: 'snare-dist01', name: 'Distorted Snare 1', file: '/samples/snare-dist01.wav' },
    { id: 'snare-dist02', name: 'Distorted Snare 2', file: '/samples/snare-dist02.wav' },
    { id: 'snare-dist03', name: 'Distorted Snare 3', file: '/samples/snare-dist03.wav' },
    { id: 'snare-electro', name: 'Electro Snare', file: '/samples/snare-electro.wav' },
    { id: 'snare-lofi01', name: 'Lo-Fi Snare 1', file: '/samples/snare-lofi01.wav' },
    { id: 'snare-lofi02', name: 'Lo-Fi Snare 2', file: '/samples/snare-lofi02.wav' },
    { id: 'snare-modular', name: 'Modular Snare', file: '/samples/snare-modular.wav' },
    { id: 'snare-noise', name: 'Noise Snare', file: '/samples/snare-noise.wav' },
    { id: 'snare-pinch', name: 'Pinch Snare', file: '/samples/snare-pinch.wav' },
    { id: 'snare-punch', name: 'Punch Snare', file: '/samples/snare-punch.wav' },
    { id: 'snare-smasher', name: 'Smasher Snare', file: '/samples/snare-smasher.wav' },
    { id: 'snare-sumo', name: 'Sumo Snare', file: '/samples/snare-sumo.wav' },
    { id: 'snare-tape', name: 'Tape Snare', file: '/samples/snare-tape.wav' },
    { id: 'snare-vinyl01', name: 'Vinyl Snare 1', file: '/samples/snare-vinyl01.wav' },
    { id: 'snare-vinyl02', name: 'Vinyl Snare 2', file: '/samples/snare-vinyl02.wav' },
  ],
  hihat: [
    { id: 'hihat-808', name: '808 Hi-Hat', file: '/samples/hihat-808.wav' },
    { id: 'hihat-acoustic01', name: 'Acoustic Hi-Hat 1', file: '/samples/hihat-acoustic01.wav' },
    { id: 'hihat-acoustic02', name: 'Acoustic Hi-Hat 2', file: '/samples/hihat-acoustic02.wav' },
    { id: 'hihat-analog', name: 'Analog Hi-Hat', file: '/samples/hihat-analog.wav' },
    { id: 'hihat-digital', name: 'Digital Hi-Hat', file: '/samples/hihat-digital.wav' },
    { id: 'hihat-dist01', name: 'Distorted Hi-Hat 1', file: '/samples/hihat-dist01.wav' },
    { id: 'hihat-dist02', name: 'Distorted Hi-Hat 2', file: '/samples/hihat-dist02.wav' },
    { id: 'hihat-electro', name: 'Electro Hi-Hat', file: '/samples/hihat-electro.wav' },
    { id: 'hihat-plain', name: 'Plain Hi-Hat', file: '/samples/hihat-plain.wav' },
    { id: 'hihat-reso', name: 'Reso Hi-Hat', file: '/samples/hihat-reso.wav' },
    { id: 'hihat-ring', name: 'Ring Hi-Hat', file: '/samples/hihat-ring.wav' },
  ],
  openhat: [
    { id: 'openhat-808', name: '808 Open Hat', file: '/samples/openhat-808.wav' },
    { id: 'openhat-acoustic01', name: 'Acoustic Open Hat', file: '/samples/openhat-acoustic01.wav' },
    { id: 'openhat-analog', name: 'Analog Open Hat', file: '/samples/openhat-analog.wav' },
    { id: 'openhat-slick', name: 'Slick Open Hat', file: '/samples/openhat-slick.wav' },
    { id: 'openhat-tight', name: 'Tight Open Hat', file: '/samples/openhat-tight.wav' },
  ],
  tom: [
    { id: 'tom-808', name: '808 Tom', file: '/samples/tom-808.wav' },
    { id: 'tom-acoustic01', name: 'Acoustic Tom 1', file: '/samples/tom-acoustic01.wav' },
    { id: 'tom-acoustic02', name: 'Acoustic Tom 2', file: '/samples/tom-acoustic02.wav' },
    { id: 'tom-analog', name: 'Analog Tom', file: '/samples/tom-analog.wav' },
    { id: 'tom-chiptune', name: 'Chiptune Tom', file: '/samples/tom-chiptune.wav' },
    { id: 'tom-fm', name: 'FM Tom', file: '/samples/tom-fm.wav' },
    { id: 'tom-lofi', name: 'Lo-Fi Tom', file: '/samples/tom-lofi.wav' },
    { id: 'tom-rototom', name: 'Rototom', file: '/samples/tom-rototom.wav' },
    { id: 'tom-short', name: 'Short Tom', file: '/samples/tom-short.wav' },
  ],
  clap: [
    { id: 'clap-808', name: '808 Clap', file: '/samples/clap-808.wav' },
    { id: 'clap-analog', name: 'Analog Clap', file: '/samples/clap-analog.wav' },
    { id: 'clap-crushed', name: 'Crushed Clap', file: '/samples/clap-crushed.wav' },
    { id: 'clap-fat', name: 'Fat Clap', file: '/samples/clap-fat.wav' },
    { id: 'clap-slapper', name: 'Slapper Clap', file: '/samples/clap-slapper.wav' },
    { id: 'clap-tape', name: 'Tape Clap', file: '/samples/clap-tape.wav' },
  ],
  crash: [
    { id: 'crash-808', name: '808 Crash', file: '/samples/crash-808.wav' },
    { id: 'crash-acoustic', name: 'Acoustic Crash', file: '/samples/crash-acoustic.wav' },
    { id: 'crash-noise', name: 'Noise Crash', file: '/samples/crash-noise.wav' },
    { id: 'crash-tape', name: 'Tape Crash', file: '/samples/crash-tape.wav' },
  ],
  ride: [
    { id: 'ride-acoustic01', name: 'Acoustic Ride 1', file: '/samples/ride-acoustic01.wav' },
    { id: 'ride-acoustic02', name: 'Acoustic Ride 2', file: '/samples/ride-acoustic02.wav' },
  ],
  percussion: [
    { id: 'cowbell-808', name: '808 Cowbell', file: '/samples/cowbell-808.wav' },
    { id: 'shaker-analog', name: 'Analog Shaker', file: '/samples/shaker-analog.wav' },
    { id: 'shaker-shuffle', name: 'Shuffle Shaker', file: '/samples/shaker-shuffle.wav' },
    { id: 'shaker-suckup', name: 'Suckup Shaker', file: '/samples/shaker-suckup.wav' },
    { id: 'perc-808', name: '808 Perc', file: '/samples/perc-808.wav' },
    { id: 'perc-chirpy', name: 'Chirpy Perc', file: '/samples/perc-chirpy.wav' },
    { id: 'perc-hollow', name: 'Hollow Perc', file: '/samples/perc-hollow.wav' },
    { id: 'perc-laser', name: 'Laser Perc', file: '/samples/perc-laser.wav' },
    { id: 'perc-metal', name: 'Metal Perc', file: '/samples/perc-metal.wav' },
    { id: 'perc-nasty', name: 'Nasty Perc', file: '/samples/perc-nasty.wav' },
    { id: 'perc-short', name: 'Short Perc', file: '/samples/perc-short.wav' },
    { id: 'perc-tambo', name: 'Tambo Perc', file: '/samples/perc-tambo.wav' },
    { id: 'perc-tribal', name: 'Tribal Perc', file: '/samples/perc-tribal.wav' },
    { id: 'perc-weirdo', name: 'Weirdo Perc', file: '/samples/perc-weirdo.wav' },
  ]
};

// 獲取特定類型的音檔
export const getSamplesByType = (type: string) => {
  return DRUM_SAMPLES[type as keyof typeof DRUM_SAMPLES] || [];
};

// 獲取所有音檔
export const getAllSamples = () => {
  return Object.values(DRUM_SAMPLES).flat();
};

// 根據ID查找音檔
export const getSampleById = (id: string) => {
  const allSamples = getAllSamples();
  return allSamples.find(sample => sample.id === id);
};

// 根據Sample ID尋找其所屬的鼓件類型
export const getSampleTypeById = (id: string) => {
  for (const [type, samples] of Object.entries(DRUM_SAMPLES)) {
    if (samples.some(sample => sample.id === id)) {
      return type;
    }
  }
  return null;
};
